<template>
  <div class="after-sales-page">
    <!-- 顶部导航栏 -->
    <header class="after-sales-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <div class="nav-back-wrapper">
          <button class="nav-back-btn" @click="goBack">
            <i class="el-icon-arrow-left"></i>
          </button>
        </div>
        <div class="nav-title">售后申请</div>
        <div style="width: 28px;"></div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="after-sales-content" :style="{paddingTop: (statusBarHeight + 80) + 'px'}">
      <!-- 设备卡片列表 -->
      <div class="device-cards">
        <!-- 智能手表 -->
        <div class="device-card">
          <div class="device-image-wrapper">
            <img src="./img/ef3bd5f70b7a1aa44a632cf62e0338f6.png" alt="智能手表" class="device-card-image" />
          </div>
        </div>
        
        <!-- 血压计 -->
        <div class="device-card">
          <div class="device-image-wrapper">
            <img src="./img/xy.jpg" alt="血压计" class="device-card-image" />
          </div>
        </div>
        
        <!-- 心电记录仪 -->
        <div class="device-card">
          <div class="device-image-wrapper">
            <img src="./img/xd.jpg" alt="心电记录仪" class="device-card-image" />
          </div>
        </div>
      </div>

      <!-- 说明文字 -->
      <div class="description-card">
        <p class="description-text">如果您的设备出现问题,可以先试试关机重启。如仍有问题请联系在线客服。</p>
      </div>

      <!-- 客服咨询按钮 -->
      <div class="service-button-wrapper">
        <button class="service-consult-btn" @click="openCustomerService">
          客服咨询
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';

export default {
  name: 'AfterSales',
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight'])
  },
  mounted() {
    document.title = '售后申请';
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    
    /**
     * 打开客服页面
     * 使用统一的在线客服链接，Android 和 iOS 都适用
     */
    openCustomerService() {
      console.log('打开客服页面');
      
      // 统一的客服链接（Android 和 iOS 都使用此链接）
      const customerServiceUrl = 'https://webchat-bj.tinetcloud.com/chat.html?accessId=50c33896-5172-49a9-a2eb-9c0a25b6c5a2&language=zh_CN';
      
      try {
        console.log('客服链接:', customerServiceUrl);
        
        // 跳转到客服页面
        window.location.href = customerServiceUrl;
        this.$message.success('正在打开客服...');
        
      } catch (error) {
        console.error('打开客服失败:', error);
        this.$message.error('打开客服失败，请重试');
      }
    }
  }
};
</script>

<style scoped lang="less">
.after-sales-page {
  min-height: 100vh;
  background-color: #F2F3F5;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

/* 顶部导航栏 */
.after-sales-header {
  position: relative;
  width: 100%;
  min-height: 220px;
  overflow: hidden;
  margin-bottom: 0;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.header-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.header-nav {
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  min-height: 44px;
}

.nav-back-wrapper {
  flex-shrink: 0;
}

.nav-back-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  color: #000000;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nav-back-btn i {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}

.nav-back-btn:hover {
  background: #f5f5f5;
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-back-btn:active {
  transform: translateY(0) scale(0.95);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.nav-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
}

/* 内容区域 */
.after-sales-content {
  width: 100%;
  padding: 20px 16px;
  position: absolute;
  top: 0;
  z-index: 10;
}

/* 设备卡片列表 */
.device-cards {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.device-card {
  flex: 1;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #F0F0F0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  transition: all 0.3s ease;
  
  &:active {
    transform: scale(0.98);
    background: #F8F9FA;
  }
}

.device-image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.device-card-image {
  width: 100%;
  height: auto;
  max-width: 60px;
  max-height: 70px;
  object-fit: contain;
}

/* 说明文字卡片 */
.description-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #F0F0F0;
  margin-bottom: 20px;
}

.description-text {
  font-size: 15px;
  line-height: 1.6;
  color: #333333;
  text-align: left;
  margin: 0;
}

/* 客服咨询按钮 */
.service-button-wrapper {
  width: 100%;
  padding: 0;
}

.service-consult-btn {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #00C275 0%, #45D968 100%);
  border: none;
  border-radius: 24px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 194, 117, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: linear-gradient(135deg, #00a865 0%, #3a95e5 100%);
    box-shadow: 0 4px 12px rgba(0, 194, 117, 0.4);
    transform: translateY(-2px);
  }
  
  &:active {
    transform: scale(0.98);
    box-shadow: 0 2px 8px rgba(0, 194, 117, 0.4);
  }
}

/* 响应式设计 */
@media (max-width: 375px) {
  .device-cards {
    gap: 8px;
  }
  
  .device-card {
    padding: 12px;
    min-height: 100px;
  }
  
  .device-card-image {
    max-width: 45px;
    max-height: 55px;
  }
  
  .description-card {
    padding: 16px 12px;
  }
  
  .description-text {
    font-size: 14px;
  }
  
  .service-consult-btn {
    height: 44px;
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/binding/afterSales.vue